import {
  BundleBot,
  BundleBotHeading,
  BundleBotLink,
  BundleBotText,
} from '@components/BundleBot';
import { EnergyBasketFragment } from '@generated/gql/graphql';

import { EV_BANNER_ID } from '../constants';

interface EnergyBotProps {
  energy: Nullable<EnergyBasketFragment>;
  showEVBanner: boolean;
}

const EnergyBot = ({ energy, showEVBanner }: EnergyBotProps) => {
  if (!energy || !showEVBanner) {
    return null;
  }

  const scrollToBanner = () => {
    const element = document.getElementById(EV_BANNER_ID);
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <BundleBot>
      <>
        <BundleBotHeading>Do you own an electric vehicle?</BundleBotHeading>
        <BundleBotText>
          Find out more about our new variable{' '}
          <BundleBotLink onClick={scrollToBanner}>
            Electric Vehicle Tariff
          </BundleBotLink>
          &hellip;
        </BundleBotText>
      </>
    </BundleBot>
  );
};

export { EnergyBot };
